// services/payments.js
import axiosInstance from './axiosInstance';

const PAYMENTS_API_URL = '/pagamentos_a_fornecedores';

const paymentsService = {
  async get(idempresa, startDate, endDate) {
    try {
      const response = await axiosInstance.get(`${PAYMENTS_API_URL}/get.php?idempresa=${idempresa}&start_date=${startDate}&end_date=${endDate}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter pagamentos:', error);
      return [];
    }
  },

  async set(paymentData) {
    try {
      const response = await axiosInstance.post(`${PAYMENTS_API_URL}/set.php`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar pagamento:', error);
      throw error;
    }
  },

  // Construir URLs de impressão para recibos de fornecedores
  getPdfUrl(idempresa, numero) {
    const baseUrl = axiosInstance.defaults.baseURL || '';
    return `${baseUrl}${PAYMENTS_API_URL}/pdf.php?idempresa=${idempresa}&numero=${encodeURIComponent(numero)}`;
  },

  getReceiptUrl(idempresa, numero) {
    const baseUrl = axiosInstance.defaults.baseURL || '';
    return `${baseUrl}${PAYMENTS_API_URL}/receipt.php?idempresa=${idempresa}&numero=${encodeURIComponent(numero)}`;
  },

  // Helper para decidir entre A4 (pdf) e 80mm (receipt)
  getPrintUrl(idempresa, numero, pageSize = 'a4') {
    return pageSize === '80mm'
      ? this.getReceiptUrl(idempresa, numero)
      : this.getPdfUrl(idempresa, numero);
  }
};

export default paymentsService;
